<template>
  <div>

    <div class="form">
      <validation-observer
          v-slot="{ handleSubmit }"
          ref="refFormObserver"
      >
        <b-form
            ref="form"
            @submit.stop.prevent="handleSubmit(createOrUpdateProgram($event))"
            class="form validate"
        >

          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="name"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Название')"
                  label-for="name"
              >
                <b-form-input
                    type="text"
                    trim
                    v-model="form.name"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="icon"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Иконка')"
                  label-for="icon"
              >
                <b-form-file
                    type="file"
                    trim
                    v-model="form.icon"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="subject_id"
            >
              <b-form-group
                  :label="$t('Выберите предмет')"
                  label-for="subject_id"
              >
                <v-select
                    name="teacher_id"
                    :options="subjects"
                    label="name"
                    v-model="form.subject_id"
                    :reduce="model => model.id"
                >
                </v-select>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="price"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Цена за месяц')"
                  label-for="price"
              >
                <b-form-input
                    type="number"
                    trim
                    v-model="form.price"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="teacher_price"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Стоимость учителя в месяц')"
                  label-for="teacher_price"
              >
                <b-form-input
                    type="number"
                    trim
                    v-model="form.teacher_price"
                />
              </b-form-group>
            </validation-provider>
          </div>
          <div class="select-wrapper">
            <validation-provider
                v-slot="validationContext"
                name="description"
                :rules="{required: true}"
            >
              <b-form-group
                  :label="$t('Описание')"
                  label-for="description"
              >
                <b-form-input
                    type="text"
                    trim
                    v-model="form.description"
                />
              </b-form-group>
            </validation-provider>
          </div>

          <b-button v-if="!form.id" type="submit" variant="primary"> {{ $t('Создать программу') }}</b-button>
          <template v-else >
            <b-button type="submit" variant="primary"> {{ $t('Редактировать программу') }}</b-button>
            <b-button class="ml-2" @click="removeEditing" type="reset" variant="warning"> {{$t('Закрыть редактирование') }}
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
        :columns="columns"
        :rows="programs"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
        :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
          slot="table-row"
          slot-scope="props"
      >

        <!-- Column: Name -->
        <div
            v-if="props.column.field === 'icon'"
            class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.icon }}</span>
        </div>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="editProgram(props.row.id)">
                <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteProgram(props.row.id)">
                <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
          slot="pagination-bottom"
          slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
                v-model="pageLength"
                :options="['3','5','10']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>

import {
  BAvatar,
  BBadge,
  BButton,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BPagination,
  BFormFile
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {createNamespacedHelpers} from 'vuex';
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import formattedDate from '@/mixins/formattedDate'

const {mapState, mapActions} = createNamespacedHelpers('programs')

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormInvalidFeedback,
    BForm,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
    flatPickr,
    BFormFile
  },
  mixins: [formattedDate],
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Название',
          field: 'name',
        },
        {
          label: 'Иконка',
          field: 'icon',
        },
        {
          label: 'Предмет',
          field: 'subject.name',
        },
        {
          label: 'Цена',
          field: 'price',
        },
        {
          label: 'Цена учителя',
          field: 'teacher_price',
        },
        {
          label: 'Описание',
          field: 'description',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      searchTerm: '',
      form: {
        name: '',
        description: '',
        icon: [],
        price: '',
        teacher_price: '',
        subject_id: '',
      },
      activeSubject: {},
    }
  },
  computed: {
    ...mapState({
      programs: state => state.programs
    }),
    subjects() {
      return this.$store.state.subjects.subjects
    }
  },
  methods: {
    ...mapActions(['getPrograms', 'updateOrCreateProgram', 'deleteProgramRecord']),
    createOrUpdateProgram() {
      let subjectData = new FormData();
      subjectData.append('name', this.form.name);
      subjectData.append('icon', this.form.icon);
      subjectData.append('description', this.form.description);
      subjectData.append('price', this.form.price);
      subjectData.append('teacher_price', this.form.teacher_price);
      subjectData.append('subject_id', this.form.subject_id);
      let message = {
        title: 'Программа была создана',
        message: 'Программа создана'
      }
      if (this.form.id) {
        subjectData.append('id', this.form.id);
        message = {
          title: 'Программа была отредактирована',
          message: 'Вы успешно отредактировали программу'
        }
      }
      this.updateOrCreateProgram(subjectData)
          .then(() => {
            this.removeEditing()
            this.$bvToast.toast(this.$t(message.title), {
              title: this.$t(message.message),
              variant: 'success',
              solid: true,
            })
          })
          .catch(err => {
            this.$bvToast.toast(this.$t('Ошибка сервера, попробуйте позже'), {
              title: this.$t('Ошибка сервера, обратитесь к администратору'),
              variant: 'danger',
              solid: true,
            })
          })

    },
    closeEditing() {
      this.activeTrial = {}
    },
    deleteProgram(id) {
      this.$bvModal
          .msgBoxConfirm('Пожалуйста, подтвердите, что вы хотите удалить эту программу. Данный ' +
              'предмет может использоваться учителями в работе', {
            title: 'Подтверждение',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Да',
            cancelTitle: 'Нет',
            cancelVariant: 'primary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(res => {
            if (res) {
              this.deleteProgramRecord(id)
                .then(() => {
                  this.$bvToast.toast(this.$t('Программа была успешно удалена'), {
                    title: this.$t('Вы успешно удалили учебную программу'),
                    variant: 'warning',
                    solid: true,
                  })
                })
                  .catch(() => {
                    this.$bvToast.toast(this.$t('Ошибка сервера, попробуйте позже'), {
                      title: this.$t('Ошибка сервера, попробуйте позже или обратитесь к администратору'),
                      variant: 'danger',
                      solid: true,
                    })
                  })
            }
          })

    },
    editProgram(id) {
      let activeProgram = this.programs.find(program => program.id === id);
      this.form = {
        name: activeProgram.name,
        description: activeProgram.description,
        icon: activeProgram.icon,
        price: activeProgram.price,
        teacher_price: activeProgram.teacher_price,
        subject_id: activeProgram.subject_id,
        id: activeProgram.id,
      }
    },
    removeEditing() {
      this.form = {
        name: '',
        description: '',
        icon: [],
        price: '',
        teacher_price: '',
        subject_id: '',
      }
    }
  },
  created() {
    if (this.subjects.length === 0) {
      this.$store.dispatch('subjects/getSubjects');
    }
    this.getPrograms()
  }
}
</script>

<style scoped>

</style>
